import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './KarsilamaSayfasi.css';

/*
 * KVKK Aydınlatma Metni ve Gizlilik Politikası sayfaları.
 * NOT: Bu metinler genel bir şablondur; yayına almadan önce veri sorumlusunun
 * unvan/adres bilgileri doldurulmalı ve bir hukukçu tarafından gözden geçirilmelidir.
 */

const VERI_SORUMLUSU = 'Diyet-Takip'; // TODO: Şirket kurulunca ticari unvan ile güncellenecek
const ILETISIM_EPOSTA = 'destek@diyet-takip.com'; // TODO: Gerçek iletişim adresi ile güncellenecek

function Bolum({ baslik, children }) {
  return (
    <div className="mb-4">
      <h5 className="fw-bold mb-2" style={{ color: 'var(--accent-primary)' }}>{baslik}</h5>
      <div style={{ color: 'var(--text-main)', fontSize: '0.95rem', lineHeight: 1.7 }}>{children}</div>
    </div>
  );
}

function AydinlatmaMetni() {
  return (
    <>
      <h2 className="fw-bolder mb-1" style={{ color: 'var(--text-main)' }}>KVKK Aydınlatma Metni</h2>
      <p className="mb-4" style={{ color: 'var(--text-muted)' }}>
        6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında kişisel verilerinizin işlenmesine ilişkin bilgilendirme.
      </p>

      <Bolum baslik="1. Veri Sorumlusu">
        <p>Kişisel verileriniz, veri sorumlusu sıfatıyla <strong>{VERI_SORUMLUSU}</strong> tarafından, aşağıda açıklanan kapsamda işlenmektedir. İletişim: <a href={`mailto:${ILETISIM_EPOSTA}`}>{ILETISIM_EPOSTA}</a></p>
      </Bolum>

      <Bolum baslik="2. İşlenen Kişisel Veriler">
        <p><strong>Platform kullanıcıları (diyetisyen / klinik yöneticisi) için:</strong> ad-soyad, kullanıcı adı, e-posta adresi, telefon numarası, şifre (geri döndürülemez şekilde şifrelenmiş/hash'lenmiş olarak), abonelik ve kullanım kayıtları, destek talepleri.</p>
        <p className="mb-0"><strong>Danışan kayıtları için:</strong> Diyetisyen kullanıcılarımız, danışanlarına ait ad-soyad, iletişim bilgileri, doğum tarihi, boy-kilo ve vücut ölçüleri, beslenme planları ve sağlıkla ilgili notlar gibi <strong>özel nitelikli kişisel veri</strong> içerebilecek kayıtları platforma girebilir. Bu veriler bakımından diyetisyen <strong>veri sorumlusu</strong>, {VERI_SORUMLUSU} ise <strong>veri işleyen</strong> konumundadır. Danışanlardan gerekli açık rızanın alınması diyetisyenin sorumluluğundadır.</p>
      </Bolum>

      <Bolum baslik="3. İşleme Amaçları ve Hukuki Sebepler">
        <ul className="mb-0">
          <li>Üyelik sözleşmesinin kurulması ve ifası (KVKK m.5/2-c),</li>
          <li>Platform hizmetlerinin sunulması, randevu ve danışan takibi işlevlerinin çalıştırılması,</li>
          <li>Hesap güvenliğinin sağlanması ve yetkisiz erişimin önlenmesi (meşru menfaat, m.5/2-f),</li>
          <li>Yasal yükümlülüklerin yerine getirilmesi (m.5/2-ç),</li>
          <li>Açık rızanızın bulunması hâlinde tanıtım/bilgilendirme iletişimi (m.5/1).</li>
        </ul>
      </Bolum>

      <Bolum baslik="4. Verilerin Aktarılması">
        <p className="mb-0">Verileriniz; barındırma ve veritabanı hizmeti aldığımız yurt dışında sunucuları bulunan hizmet sağlayıcılara (ör. Vercel, Render, Supabase) yalnızca hizmetin gerektirdiği ölçüde ve KVKK m.9'a uygun şekilde aktarılır. Verileriniz üçüncü kişilere satılmaz, pazarlama amacıyla paylaşılmaz. Yetkili kamu kurumlarının hukuka uygun talepleri saklıdır.</p>
      </Bolum>

      <Bolum baslik="5. Saklama Süresi">
        <p className="mb-0">Kişisel veriler, üyelik ilişkisi süresince ve ilgili mevzuatta öngörülen zamanaşımı süreleri boyunca saklanır; sürenin sonunda silinir, yok edilir veya anonim hâle getirilir. Hesabınızı sildirmek için bizimle iletişime geçebilirsiniz.</p>
      </Bolum>

      <Bolum baslik="6. Haklarınız (KVKK m.11)">
        <p>Kişisel verilerinizin işlenip işlenmediğini öğrenme, işlenmişse bilgi talep etme, işleme amacını öğrenme, aktarıldığı üçüncü kişileri bilme, eksik/yanlış işlenmişse düzeltilmesini isteme, silinmesini veya yok edilmesini isteme, otomatik sistemlerce analiz sonucu aleyhinize bir sonucun ortaya çıkmasına itiraz etme ve zarara uğramanız hâlinde tazminat talep etme haklarına sahipsiniz.</p>
        <p className="mb-0">Taleplerinizi <a href={`mailto:${ILETISIM_EPOSTA}`}>{ILETISIM_EPOSTA}</a> adresine iletebilirsiniz; başvurular en geç 30 gün içinde ücretsiz olarak sonuçlandırılır.</p>
      </Bolum>
    </>
  );
}

function GizlilikPolitikasi() {
  return (
    <>
      <h2 className="fw-bolder mb-1" style={{ color: 'var(--text-main)' }}>Gizlilik ve Güvenlik Politikası</h2>
      <p className="mb-4" style={{ color: 'var(--text-muted)' }}>Verilerinizi nasıl koruduğumuza dair özet.</p>

      <Bolum baslik="Veri Güvenliği Önlemlerimiz">
        <ul className="mb-0">
          <li>Tüm bağlantılar SSL/TLS ile şifrelenir (HTTPS + HSTS).</li>
          <li>Şifreler asla düz metin saklanmaz; endüstri standardı tek yönlü hash ile korunur.</li>
          <li>Oturum yönetimi kısa ömürlü erişim token'ları ve httpOnly çerezlerle yapılır.</li>
          <li>Her diyetisyen yalnızca kendi danışanlarının verisine erişebilir; erişim kontrolü sunucu tarafında uygulanır.</li>
          <li>Giriş denemeleri hız sınırına tabidir (brute-force koruması).</li>
          <li>Veritabanı, düzenli yedekleme yapan yönetilen bir altyapıda (Supabase/PostgreSQL) barındırılır.</li>
        </ul>
      </Bolum>

      <Bolum baslik="Çerezler">
        <p className="mb-0">Platform, oturumunuzu sürdürmek için zorunlu çerezler ve tarayıcı depolaması kullanır. Reklam/izleme amaçlı üçüncü taraf çerezi kullanılmaz.</p>
      </Bolum>

      <Bolum baslik="Danışan Verileri">
        <p className="mb-0">Danışanlara ait ölçüm ve beslenme verileri yalnızca ilgili diyetisyenin hesabından erişilebilir. Bu veriler reklam, profilleme veya üçüncü taraflarla paylaşım amacıyla kullanılmaz.</p>
      </Bolum>

      <Bolum baslik="İhlal Bildirimi">
        <p className="mb-0">Kişisel verileri etkileyen bir güvenlik ihlali tespit edilirse, KVKK ve ilgili mevzuat uyarınca gerekli bildirimler yapılır ve etkilenen kullanıcılar bilgilendirilir.</p>
      </Bolum>
    </>
  );
}

function KvkkSayfasi({ sayfa = 'aydinlatma' }) {
  const navigate = useNavigate();
  return (
    <div className="landing-container" style={{ minHeight: '100vh' }}>
      <div className="aurora-background" />
      <nav className="landing-navbar">
        <Container className="d-flex justify-content-between align-items-center">
          <div className="navbar-brand-custom d-flex align-items-center gap-2" style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
            <div className="brand-icon">
              <span className="material-symbols-outlined">clinical_notes</span>
            </div>
            <span className="brand-text">Diyet-Takip</span>
          </div>
          <Button variant="primary" size="sm" className="login-btn-nav" onClick={() => navigate('/giris')}>Giriş Yap</Button>
        </Container>
      </nav>

      <Container style={{ position: 'relative', zIndex: 1, paddingTop: '7rem', paddingBottom: '4rem', maxWidth: '860px' }}>
        <Card className="glass-card">
          <Card.Body className="p-4 p-md-5">
            {sayfa === 'gizlilik' ? <GizlilikPolitikasi /> : <AydinlatmaMetni />}
            <hr style={{ borderColor: 'var(--border-color)' }} />
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
              <small style={{ color: 'var(--text-muted)' }}>Son güncelleme: {new Date().getFullYear()}</small>
              <div className="d-flex gap-3">
                {sayfa === 'gizlilik' ? (
                  <Button variant="link" className="p-0" onClick={() => navigate('/kvkk')}>KVKK Aydınlatma Metni →</Button>
                ) : (
                  <Button variant="link" className="p-0" onClick={() => navigate('/gizlilik-politikasi')}>Gizlilik Politikası →</Button>
                )}
              </div>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default KvkkSayfasi;
